"use client";

import { SiteHero, Ladder, SplitRow, FullBleedPhoto, FaqList, CtaBand, RelatedLinks } from "@/components/marketing/site-ui";
import { ProfileScoreMock } from "@/components/marketing/site-mocks";
import { useSiteContent } from "@/components/marketing/use-site-content";

export function ReputationClient() {
  const c = useSiteContent();
  const page = c.reputationPage;

  return (
    <>
      <SiteHero
        eyebrow={page.eyebrow}
        title={page.title}
        lede={page.lede}
        primaryLabel={page.primary}
        note={page.note}
        aside={<ProfileScoreMock />}
      />

      <section className="border-y border-neutral-200 bg-white py-14 md:py-20">
        <div className="gs-page">
          <Ladder steps={page.ladder} />
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="gs-page">
          <SplitRow
            eyebrow={page.scoreEyebrow}
            title={page.scoreTitle}
            body={page.scoreBody}
            items={page.scoreItems}
            flip
            aside={
              /* The four things a reputation is actually made of here, as a list of evidence
                 types rather than a chart. There is no data worth charting at this stage and
                 an invented graph would be a fabricated statistic. */
              <div className="divide-y divide-neutral-200 rounded-[1.75rem] border border-neutral-200 bg-white">
                {page.evidence.map((entry) => (
                  <div key={entry.title} className="p-6 md:p-7">
                    <p className="text-[15px] font-bold text-neutral-900">{entry.title}</p>
                    <p className="mt-1.5 text-[14px] leading-relaxed text-neutral-600">{entry.body}</p>
                  </div>
                ))}
              </div>
            }
          />
        </div>
      </section>

      <FullBleedPhoto
        src="/images/leaderboard-toast.webp"
        alt={page.photoAlt}
        eyebrow={page.photoEyebrow}
        title={page.photoTitle}
        body={page.photoBody}
      />

      <section className="py-16 md:py-20">
        <div className="gs-page">
          {/* The measure goes on an inner box: .gs-page centres, so a narrower max-width on it
              would recentre this section and move the page's left edge. */}
          <div className="max-w-4xl">
            <FaqList heading={c.common.faqHeading} items={page.faq} />
          </div>
        </div>
      </section>

      <RelatedLinks
        links={[
          { href: "/features/events", title: c.features.events.name, body: c.features.events.tagline },
          { href: "/safety", title: c.company.safety, body: c.company.safetyTagline },
          { href: "/faq", title: c.company.faq, body: c.company.faqTagline },
        ]}
      />

      <div className="pt-14 md:pt-20">
        <CtaBand />
      </div>
    </>
  );
}
